export default __webpack_public_path__ + "static/media/facebook_purple.49712b76.svg";